// Vue 2 mixin port of vue3/src/features/customer-display/useSubmitRating.js
// (a Composition API composable - converted to a plain Options API mixin;
// identical behavior, same reactive "is a request currently in flight" guard
// that prevents a double submit from a fast double tap or a racing helper
// intent). The directly unit-tested, framework-free logic this wraps stays
// in shared/customer-display/submitRating.js, unchanged, imported as-is.
import { submitRating, OUTCOME } from '@shared/customer-display/submitRating';
import { API_BASE_URL } from './apiBaseUrl';

export const SUBMIT_RATING_OUTCOME = OUTCOME;

export default {
  data() {
    return {
      ratingSubmitting: false
    };
  },
  methods: {
    async submitRatingViaMixin({ sessionId, ratingToken, rating }) {
      if (this.ratingSubmitting) return { outcome: OUTCOME.NETWORK_ERROR, session: null, skipped: true };
      this.ratingSubmitting = true;
      try {
        return await submitRating({ baseUrl: API_BASE_URL, sessionId, ratingToken, rating });
      } finally {
        this.ratingSubmitting = false;
      }
    }
  }
};
